import { render, staticRenderFns } from "./IpfsInfo.vue?vue&type=template&id=3a1781d6&"
import script from "./IpfsInfo.vue?vue&type=script&lang=js&"
export * from "./IpfsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports